import React from "react";
import type { ReactNode } from "react";
import { RULE, SLATE } from "../styles";

interface THProps {
  children: ReactNode;
}

export default function TH({ children }: THProps) {
  return (
    <th
      style={{
        textAlign: "left",
        textTransform: "uppercase",
        letterSpacing: "0.4px",
        fontSize: 12,
        fontWeight: 700,
        color: SLATE,
        border: "1px solid " + RULE,
        padding: "12px 14px",
        background: "#fff",
      }}
    >
      {children}
    </th>
  );
}